const __WEBPACK_NAMESPACE_OBJECT__ = require("@x82-softworks/clone-merge");